/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description
 */

import type { TopListable } from '@zcode/bizos'
import type { Listable, MaybeEmptyProperty } from '@zcode/state-type'

/**
 * Returns the traktor property ID for an entity
 *
 * @param  entity
 * @param  [entity.buildingId] - eg. 123 if in a building, else undefined or null
 * @param  [entity.pbId] - eg. 44 if in a PB, else undefined or null
 * @param  [entity.listingId] - eg. 456 if a listing, else undefined or null
 * @param  [entity.plId] - eg. 33 if in a PL, else undefined or null
 * @returns
 */
export const getTraktorEntityId = (
  entity?: Pick<
    Listable | MaybeEmptyProperty | TopListable,
    'buildingId' | 'listingId' | 'pbId' | 'plId'
  >
) => {
  if (entity) {
    const { buildingId, listingId, pbId, plId } = entity
    if (buildingId) {
      return pbId ? (`b-${buildingId}:p-${pbId}` as const) : (`b-${buildingId}` as const)
    }
    if (listingId) {
      return plId ? (`l-${listingId}:p-${plId}` as const) : (`l-${listingId}` as const)
    }
  }
  return null
}
